import { Download, Link2 } from "lucide-react";
import { toast } from "sonner";

export const OpenLetter = () => {
  const copyLink = async () => {
    const url = `${window.location.origin}/joel-bruce-open-letter.pdf`;
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Letter link copied — share it anywhere.");
    } catch {
      toast.info(`Share this link: ${url}`);
    }
  };

  return (
    <section
      id="letter"
      className="scroll-mt-36 border-t border-[#DCDCD6] bg-[#EBEBE6] px-6 py-24 md:scroll-mt-24 md:py-32"
      data-testid="letter-section"
    >
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#666666]">
          From Joel
        </p>
        <h2 className="mt-4 font-serif text-3xl font-light leading-tight tracking-tight md:text-5xl">
          An Open Letter to Our Community
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-[#666666]">
          Joel's letter to the residents of District #3 — on grassroots
          decision-making, respectful consultation, and holding municipal
          leaders to a real code of conduct. Download it, or share it with a
          neighbour.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="/joel-bruce-open-letter.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="letter-download-button"
            className="flex items-center gap-3 border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Read the letter
            <Download className="h-4 w-4" />
          </a>
          <button
            onClick={copyLink}
            data-testid="letter-share-button"
            className="flex items-center gap-3 border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Copy share link
            <Link2 className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
